<template>
  
  <div class="tab-cover-wrap ">
     <div class=" py-2 pl-2 ">
            <p class="text-[16px] font-normal ">
              Your business address is <span >14B, Oluwale Oshodi Avenue, Ikeja, Lagos, Nigeria.</span> This is the same address as provided in the organization Information section. If you need to make changes, please go to your organization information to edit.
            </p>
        </div> 
    <h1 class="text-[14px] font-semibold text-[#14171F] ml-2">
      Is your registered business address the same as your practice/business address?
    </h1>

   <div class="business-status pt-4">
      <div class="">
        <div class="flex  justify-between items-center mb-8 pl-2">
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'Yes' }]" @click="selectOption('Yes')"></div>
            <p class="ml-2 text-[64px] font-bold text-[#383F51]">Yes</p>
          </div>
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'No' }]" @click="selectOption('No')"></div>
            <p class="ml-2 text-[14px] font-bold text-rose-500">No</p>
          </div>
        </div>

        <div v-if="selected === 'Yes'">
          <Yes @openVerify="openVerify"/>
        </div>
        
        <div v-if="selected === 'No'" >
          <No />
        </div>
      </div>

    </div>
  </div>
</template>

 <script>
 import Yes from './modules/Yes.vue';
 import No from './modules/No.vue';

export default {
   components: {
        Yes,
        No,
       
    },
  data() {
    return {
      selected: null, 
    };
  },
    methods: {
      openVerify(locationData) {
        this.$emit('openVerify', locationData); 

      },
      selectOption(option) {
      this.selected = option;
    },
      selectTab(index) {
            this.selectedIndex = index;
        },
    },

  };
  </script>
 
 <style scoped>
 span {
      color: #09B78A; 
 }
 .business-status>:nth-child(1)>:nth-child(1){
  width: 35%;
 }
 .color-box.active {
  background-color: #FFA600;
}

.color-box {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  border: 1px solid #C5C4D4;
  cursor: pointer;
}

.box-cover>p {
  color: #383F51;
  font-size: 14px;
  font-weight: 400;
}
</style>
